import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useNavLinksContext } from '../../contexts/NavLinksContext';
import { useAppContext } from '../../contexts/Storage';
import { ListPageTemplate } from '../../components/Templates';
import { useLedgers } from '../../components/Accounts';

const LedgersListPage: React.FC = () => {
  const { setNavLinks } = useNavLinksContext();
  const { selectedRecord } = useAppContext();
  const navigate = useNavigate();

  const {
    listItems,
    isLoading,
    hasRequiredParams,
    pagination,
    handlePageChange,
  } = useLedgers();

  useEffect(() => {
    setNavLinks({
      links: [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/records', label: 'Books' },
        ...(selectedRecord
          ? [{ to: '/records/accounts/ledgers', label: selectedRecord.record_name || 'Ledgers' }]
          : []),
      ],
    });
  }, [setNavLinks, selectedRecord]);

  if (!selectedRecord) {
    return (
      <div className="h-shink-from-navbar h-fill-from-navbar pl-2 bg-bg_grey_light text-dark overflow-y-scroll">
        <div className="bg-light rounded-lg p-8 text-center">
          <p className="text-grey_dark mb-4">Please select a record to view ledgers.</p>
          <Link
            to="/records"
            className="text-primary hover:text-primary_dark underline"
          >
            Go to Records
          </Link>
        </div>
      </div>
    );
  }

  return (
    <ListPageTemplate
      title="Ledgers"
      description="Manage and view all ledger accounts"
      items={listItems}
      loading={isLoading}
      showDateRange={true}
      onItemClick={(item) => navigate(`/records/accounts/ledgers/${item.id}`)}
      emptyMessage={
        !hasRequiredParams
          ? 'Please select a record to view ledgers.'
          : 'No ledgers found for this record.'
      }
      pagination={
        pagination
          ? {
              page: pagination.page,
              lastPage: pagination.lastPage,
              total: pagination.total,
              from: pagination.from,
              to: pagination.to,
            }
          : undefined
      }
      onPageChange={handlePageChange}
      paginationLabel="ledgers"
    />
  );
};

export default LedgersListPage;
